export const pageContents = {
  jobTitles: 'jobTitles',
  costCenters: 'costCenters',
  departments: 'departments',
} as const;

export type PageContent = keyof typeof pageContents;
